import React, { useState } from 'react';

function DiscountPer({ discountRate }) {
  return (
    <>{discountRate > 0 && <span className="discount">{discountRate}%</span>}</>
  );
}

export default React.memo(DiscountPer);
